import ToastComponent from './toast.vue'
import { log } from 'util';
const Toast = {
    install: Vue => {
        const ToastChild = Vue.extend(ToastComponent)
        const instance = new ToastChild()
        instance.$mount(document.createElement('div'))
        document.body.appendChild(instance.$el)
        Vue.prototype.$toast = (text, time) => {
            if(text){
                instance.showFlag = true
                instance.text = text
            }
        }
    }
}
export default Toast